import React, { useState, useEffect } from 'react';

const Localization = () => {
  const [isUa, setIsUa] = useState(false);

  const changeLocalization = () => {
    setIsUa(!isUa);
  };

  useEffect(() => {
    const textsEN = document.getElementsByClassName('text-EN');
    const textsUA = document.getElementsByClassName('text-UA');

    for (let i = 0; i < textsEN.length; i++) {
      textsEN[i].style.display = isUa ? 'none' : 'block';
    }
    for (let i = 0; i < textsUA.length; i++) {
      textsUA[i].style.display = isUa ? 'block' : 'none';
    }
  }, [isUa]);

  return (
    <div className="localization-block">
      <div className="localization-content-block">
        <h4 className="localization-item">EN</h4>
        <div className="checkbox-localization">
          <label className="switch">
            <input
              type="checkbox"
              id="checkbox-localize"
              onChange={changeLocalization}
              checked={isUa}
            />
            <span className="slider"></span>
          </label>
        </div>
        <h4 className="localization-item">UA</h4>
      </div>
    </div>
  );
};

export default Localization;
